module.exports = __webpack_public_path__ + "static/media/Incorrect Box.5bc44bfc.svg";